import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';

// Wait for DOM to be ready
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found. Make sure you have <div id="root"></div> in your HTML.');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);